import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { FaCompressAlt } from 'react-icons/fa';
import { analytics } from '../utils/analytics';

const CompressionModal = ({ 
  show, 
  onHide, 
  onCompress, 
  fileName, 
  fileSize,
  category = 'PDF_Unlocker',
  isCompressing = false 
}) => {
  const handleCompress = () => {
    // Track compression attempt
    analytics.pdfUnlocker.compressionAttempt(fileName, 'high');
    
    // Call the parent's compression handler with 'high' compression
    onCompress('high');
  };

  const getFileSizeDisplay = (sizeInBytes) => {
    const sizeInKB = Math.round(sizeInBytes / 1024);
    if (sizeInKB > 1024) {
      return `${(sizeInKB / 1024).toFixed(1)} MB`;
    }
    return `${sizeInKB} KB`;
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FaCompressAlt className="me-2" />
          Compress PDF
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {fileSize && (
          <div className="mb-3 p-3 bg-light rounded">
            <div className="text-center">
              <FaCompressAlt className="text-primary mb-2" size={32} />
              <h6>High Compression</h6>
              <p className="mb-2">Smaller file size with optimized quality</p>
              <small className="text-muted">
                Original size: <strong>{getFileSizeDisplay(fileSize)}</strong>
              </small>
            </div>
          </div>
        )}
        
        <p className="text-center mb-0">
          This will compress your PDF to reduce file size while maintaining readability.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isCompressing}>
          Cancel
        </Button>
        <Button 
          variant="primary" 
          onClick={handleCompress}
          disabled={isCompressing}
        >
          {isCompressing ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Compressing...
            </>
          ) : (
            <>
              <FaCompressAlt className="me-2" />
              Compress & Download
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CompressionModal; 